import { render, staticRenderFns } from "./CreatePR.vue?vue&type=template&id=3a021d61&scoped=true"
import script from "./CreatePR.vue?vue&type=script&lang=js"
export * from "./CreatePR.vue?vue&type=script&lang=js"
import style0 from "./CreatePR.vue?vue&type=style&index=0&id=3a021d61&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "../../../assets/styles/inventory.css?vue&type=style&index=2&id=3a021d61&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a021d61",
  null
  
)

export default component.exports